import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './ReservationStatus.scss';
import { ReservationStatusLabel } from './statusHelpers';

interface ReservationStatusProps {
  status: string;
}

export const ReservationStatus = ({ status }: ReservationStatusProps) => {
  const statusClassNames = cx({
    [typography.t2]: true,
    [styles.confirmed]: status === ReservationStatusLabel.Confirmed,
    [styles.completed]: status === ReservationStatusLabel.Completed,
    [styles.canceled]: status === ReservationStatusLabel.Canceled,
    [styles.rebooked]: status === ReservationStatusLabel.Rebooked,
    [styles.resold]: status === ReservationStatusLabel.Sold,
  });

  return (
    <div data-testid="reservation-status" className={statusClassNames}>
      {status}
    </div>
  );
};
